import React, { PropsWithChildren } from 'react';
import { Loader, LoaderType } from '@progress/kendo-react-indicators';
import styles from './LoaderOverlay.module.scss';

type LoaderOverlayProps = {
    className?: string,
    container?: boolean,
    containerClassName?: string,
    isLoading: boolean
    height?: number | string,
    width?: number | string,
    margin?: string,
    type?: LoaderType
};

export default function LoaderOverlay(props: PropsWithChildren<LoaderOverlayProps>) {
    const {
        children,
        className,
        container,
        containerClassName,
        isLoading,
        height,
        width,
        margin,
        type = 'infinite-spinner'
    } = props;

    if (!isLoading) {
        return null;
    }

    const renderContainer = () => {
        const style = {
            height: typeof height === 'number' ? `${height}pc` : height,
            width: typeof width === 'number' ? `${width}px` : width,
            margin
        };

        return (
            <div className={`${styles.container} ${containerClassName}`} style={style}>
                {renderOverlay()}
            </div>
        )
    }

    const renderOverlay = () => (
        <div className={`${styles.overlay} ${className}`}>
            <Loader type={type} />
            {children}
        </div>
    )
    
    return container ? renderContainer() : renderOverlay();
}